import { render, staticRenderFns } from "./DragAndDropComponent.vue?vue&type=template&id=6202ff5e&scoped=true"
import script from "./DragAndDropComponent.vue?vue&type=script&lang=js"
export * from "./DragAndDropComponent.vue?vue&type=script&lang=js"
import style0 from "./DragAndDropComponent.vue?vue&type=style&index=0&id=6202ff5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6202ff5e",
  null
  
)

export default component.exports